module.exports = __webpack_public_path__ + "img/download-pdf2.428b9249.png";